import { LoggerService } from './Logger';
import { ILogger } from './types';

const _defaultLogger = {
  log: console.log,
  debug: console.log,
  info: console.log,
  warn: console.log,
  error: console.error,
};

export const logger = new LoggerService(_defaultLogger);

export const initLogger = <Tag extends string = string>(
  newLogger: ILogger<Tag>,
) => {
  logger.setLogger(newLogger);
};
